
import { SVGProps } from 'react';

const AddNote = ({
  width = 18,
  height = 28,
  fill = '#00AEC7',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 20"
    {...otherProps}>
  <path d="M1.8 19.5C1.3 19.5 0.875 19.325 0.525 18.975C0.175 18.625 0 18.2 0 17.7V2.3C0 1.8 0.175 1.375 0.525 1.025C0.875 0.675 1.3 0.5 1.8 0.5H9C9.25 0.5 9.48333 0.545667 9.7 0.637C9.91667 0.729 10.1083 0.858333 10.275 1.025L14.475 5.225C14.6417 5.39167 14.771 5.58333 14.863 5.8C14.9543 6.01667 15 6.25 15 6.5V9.55H13.5V6.5H9.9C9.65 6.5 9.43733 6.41233 9.262 6.237C9.08733 6.06233 9 5.85 9 5.6V2H1.8C1.73333 2 1.66667 2.03333 1.6 2.1C1.53333 2.16667 1.5 2.23333 1.5 2.3V17.7C1.5 17.7667 1.53333 17.8333 1.6 17.9C1.66667 17.9667 1.73333 18 1.8 18H7.125V19.5H1.8ZM1.5 18V2V18ZM13.35 12.55L14.2 13.4L10.325 17.25V18.3H11.375L15.25 14.45L16.075 15.275L12.15 19.2C12.0667 19.3 11.971 19.371 11.863 19.413C11.7543 19.4543 11.6333 19.475 11.5 19.475H9.575C9.45833 19.475 9.354 19.4333 9.262 19.35C9.17067 19.2667 9.125 19.1583 9.125 19.025V17.125C9.125 17.0083 9.15 16.896 9.2 16.788C9.25 16.6793 9.31667 16.575 9.4 16.475L13.35 12.55ZM16.075 15.275L13.35 12.55L14.65 11.25C14.8167 11.0833 15.0293 11 15.288 11C15.546 11 15.75 11.0833 15.9 11.25L17.375 12.725C17.5417 12.875 17.625 13.079 17.625 13.337C17.625 13.5957 17.5417 13.8083 17.375 13.975L16.075 15.275Z" fill={fill}/>
  </svg>
);

export default AddNote;
